// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1cYVf","header":"PatientQuestionnaire_header__hSAp9","info":"PatientQuestionnaire_info__1Osev"};